import {Component, ElementRef, Input, OnInit, Renderer2, ChangeDetectionStrategy} from '@angular/core';
import {ModalService} from '../../../../components/modal';
import {
    getOrderQtyCurrency,
    getOrderQtyMultiCurrencyInfoForOrder
} from '../../../../components/order-qty-multi-currency';
import {OverlayService} from '../../../../components/overlay';
import {DisplayDecimal, formatQuantity, SymbolDecimalsService} from '../../../../components/symbol-decimals';
import {NewOrder} from '../../../../models/order';
import {Security} from '../../../../models/security';
import {CellSizeObserverService} from '../../../../pages/dashboard/layout/cell/cell-size-observer.service';
import {WidgetInnerAlertComponent} from '../../widget-inner-alert';

@Component({
    selector: 'widget-order-max-quantity-alert',
    templateUrl: 'widget-order-max-quantity-alert.component.html',
    styleUrls: ['./widget-order-max-quantity-alert.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class WidgetOrderMaxQuantityAlertComponent extends WidgetInnerAlertComponent implements OnInit {

    @Input()
    public security: Security;

    @Input()
    public order: NewOrder;

    public maxQuantityDisplayDecimal: DisplayDecimal<string>;

    public qtyCurrency: string;

    constructor(
        elementRef: ElementRef,
        modalService: ModalService,
        overlayService: OverlayService,
        cellSizeObserverService: CellSizeObserverService,
        renderer: Renderer2,
        private symbolDecimalsService: SymbolDecimalsService
    ) {
        super(
            elementRef,
            modalService,
            overlayService,
            cellSizeObserverService,
            renderer
        );
    }

    public override ngOnInit(): void {
        const {order, security} = this;
        const symbolDecimalsInputParams = this.symbolDecimalsService.getSecurityInputParams(security);
        const symbolFormats = this.symbolDecimalsService.getSecurityFormats(security);

        this.maxQuantityDisplayDecimal = formatQuantity(
            symbolDecimalsInputParams.max.quantity,
            symbolFormats
        );

        this.qtyCurrency = getOrderQtyCurrency(security, getOrderQtyMultiCurrencyInfoForOrder(order, security));

        super.ngOnInit();
    }

}
